const testimonials = [
  {
    name: "Megan & Dave T.",
    location: "Island Estates, Clearwater",
    story:
      "We had a 5-day Caribbean cruise booked out of Tampa for our anniversary. The morning before departure, we took the kids to Clearwater Beach for one last splash. My husband's passport was in his beach bag — soaked through with salt water and sand. The cover was warped and the photo page had started to separate. The cruise line said damaged passports could be denied boarding. I called Fast Passport Center in a panic at 10 AM on a Tuesday. They walked us through emergency processing, we overnighted everything, and by Thursday afternoon he had a pristine new passport in hand. We made our Friday embarkation with time to spare. I honestly thought our $4,000 cruise was gone.",
    service: "Emergency Damaged Passport Replacement",
    timeline: "48-Hour Turnaround",
    icon: "ri-emotion-sad-line",
  },
  {
    name: "Robert H.",
    location: "Coachman Area, Clearwater",
    story:
      "I'm a lifelong Phillies fan. Every March I rent a condo near Spectrum Field for spring training. This year, some Toronto friends invited me up for Opening Week at Rogers Centre. I booked the flight from TPA through Air Canada and didn't even think about my passport until three days before departure. It had expired six months earlier. I called Fast Passport Center and explained I had tickets to four games. Their team expedited my renewal through emergency channels. I had my new passport in 72 hours and watched the Phillies take two of three from the Blue Jays. At 68 years old, I should know better — but they saved my trip without making me feel foolish.",
    service: "Emergency Passport Renewal",
    timeline: "72-Hour Turnaround",
    icon: "ri-emotion-happy-line",
  },
  {
    name: "Patricia L.",
    location: "Clearwater Beach Condo Owner",
    story:
      "My daughter in Toronto was expecting her first baby, and I planned to fly up two weeks before the due date to help. I'm a snowbird — I live in Clearwater from November through April and spend summers near my daughter in Ontario. Because I'm in Florida most of the year, my passport sat in a safe at my Toronto house. When I went to check it before booking my flight, I discovered it had expired four months ago. I was devastated — I was going to miss the birth of my first grandchild. Fast Passport Center processed an emergency renewal in less than three days. I made it to Toronto with a week to spare. My granddaughter arrived healthy, and I was there to hold her. I'll never forget what they did for our family.",
    service: "Emergency Passport Renewal for Family Travel",
    timeline: "3-Day Turnaround",
    icon: "ri-parent-line",
  },
];

export default function ClearwaterTestimonialsSection() {
  return (
    <section id="testimonials" className="py-16 md:py-20 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Real Stories
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Clearwater Travelers We Have Helped
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Beach days, spring training trips, and snowbird migrations — Clearwater residents face
            unique passport challenges. Here is how we solved them.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white rounded-lg p-6 md:p-8 border border-gray-100 hover:border-[#F6C344]/50 transition-all">
              <div className="w-10 h-10 rounded-lg bg-[#1A365D] flex items-center justify-center mb-5">
                <i className={`${t.icon} text-white text-lg`}></i>
              </div>

              <p className="text-gray-700 text-sm leading-relaxed mb-6 italic">
                &ldquo;{t.story}&rdquo;
              </p>

              <div className="border-t border-gray-100 pt-5">
                <p className="font-serif text-sm font-bold text-[#1A365D]">{t.name}</p>
                <p className="text-gray-500 text-xs mb-3">{t.location}</p>
                <div className="flex flex-wrap items-center gap-2">
                  <span className="bg-[#F6C344]/10 text-[#1A365D] text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">
                    {t.service}
                  </span>
                  <span className="bg-[#1A365D]/10 text-[#1A365D] text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">
                    {t.timeline}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}